module.exports = __webpack_public_path__ + "media/images/test-start-a99c2e9afbb512f57b7d61739f4ac9ef.png";